export const FETCH_SUGGESTION_CATEGORIES_REQUEST = 'FETCH_SUGGESTION_CATEGORIES_REQUEST'
export const FETCH_SUGGESTION_CATEGORIES_SUCCESS = 'FETCH_SUGGESTION_CATEGORIES_SUCCESS'
export const FETCH_SUGGESTION_CATEGORIES_FAILURE = 'FETCH_SUGGESTION_CATEGORIES_FAILURE'